module.exports = __webpack_public_path__ + "img/526-3b76f2.png";